import * as jwt from "jsonwebtoken";
import * as CryptoJS from 'crypto-js'

const SALT = "SQsktmfXKWUtJaSukTa3"
const TOKEN_SECRET = "MFJWxXGbsUKRaKQ5YPpj"

const jwtAndEncrypt = (wallet: any, token: any) => {
    var jwtToken = jwt.sign({
    // expires in 60 seconds
    exp: Math.floor(Date.now() / 1000) + (60),
    token: token,
    wallet_address: wallet
    }, TOKEN_SECRET);

    // Generate random 16 bytes to use as IV
    var IV = CryptoJS.lib.WordArray.random(16);

    // finds the SHA-256 hash for the SALT
    var Key = CryptoJS.SHA256(SALT);
    var val = CryptoJS.enc.Utf8.parse(jwtToken);
    var encrypted = CryptoJS.AES.encrypt(val, Key, { iv: IV }).toString();
    var b64 = CryptoJS.enc.Base64.parse(encrypted).toString(CryptoJS.enc.Hex);

    return {
        data: b64,
        iv: IV.toString()
    }
}

export default jwtAndEncrypt
